<template>
  <v-dialog :value="getToggleEditLineItemsDialog" width="500" persistent>
    <v-card :loading="getFetchAdhocInvoicesLoading">
      <v-card-title>Edit Line Items</v-card-title>

      <v-card-text>
        <template v-if="getAdhocInvoices.length > 0">
          <template v-for="(invoice, index) in getAdhocInvoices"> 
            <div :key="invoice.id" class="mb-5">
              <div class="d-flex justify-space-between align-center">
                <div>Invoice {{ invoice.id }}</div>
                <v-chip small>{{ invoice.creation_timestamp | formatCustomDate('YYYY-MM-DD HH:mm') }}</v-chip>
              </div>

              <template v-for="item in invoice.line_items">
                <LineItemCard ref="lineItem" v-model="line_items" :key="item.id" :item="item" />
              </template>
            
              <v-divider class="my-4" :class="{'d-none' : (index === getAdhocInvoices.length-1)}"></v-divider>
            </div>
          </template>
        </template>

        <template v-if="showNoInvoices">
          <div>No ad hoc invoices found</div>
        </template>
      </v-card-text>

      <v-divider></v-divider>
      
      <v-card-actions>
        <div>Total - {{ totalCreditAmount | formatPrice }}</div>

        <v-spacer></v-spacer>

        <v-btn small color="primary" @click="save">Save</v-btn>
        <v-btn small color="primary" outlined @click="close">Cancel</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
  import { mapMutations, mapActions, mapGetters } from 'vuex';

  import LineItemCard from './LineItemCard';

  export default {
    components: { LineItemCard },

    data() {
      return {
        line_items: [],
      }
    },

    computed: {
      ...mapGetters('creditnotes', ['getAdhocInvoices', 'getFetchAdhocInvoicesLoading', 'getCreditNotesProposalsActionAccount', 'getToggleEditLineItemsDialog']),
      ...mapGetters('accounts', ['getCurrentAccount']),

      totalCreditAmount() {
        return this.line_items.reduce((final, item) => {
          return final + parseFloat(item.creditAmount);
        }, 0);
      },

      validLineItems() {
        return this.$refs.lineItem.some(item => item.$v.$invalid);
      },

      showNoInvoices() {
        return !this.getFetchAdhocInvoicesLoading && this.getAdhocInvoices.length === 0;
      }
    },

    watch: {
      getToggleEditLineItemsDialog(val) {
        if (val) {
          const id = this.getCreditNotesProposalsActionAccount.account_id || this.getCurrentAccount.id;
          this.fetchAdhocInvoices(id);
        }
      }
    },

    methods: {
      ...mapMutations('creditnotes', ['UPDATE_LINE_ITEMS', 'TOGGLE_EDIT_LINE_ITEMS_DIALOG']),
      ...mapActions('creditnotes', ['fetchAdhocInvoices']),

      save() {
        if (!this.validLineItems) {
          this.UPDATE_LINE_ITEMS({lineItems: this.line_items, totalCreditAmount: this.totalCreditAmount});
          this.close();
        }else{
          console.log(this.validLineItems);
          console.log(this.line_items);
          console.log(this.$refs.lineItem);
        }
      },

      close() {
        this.reset();
        this.TOGGLE_EDIT_LINE_ITEMS_DIALOG(false);
      },

      reset() {
        this.line_items = [];
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>